const BODY_CONTAINER_CLASS = 'container pt-5 mb-3';

const classNamesConstants = {
  BODY_CONTAINER_CLASS,
};

export default classNamesConstants;
